import { v4 as uuidv4 } from 'uuid';
import { Locale } from '../types/common';
import { User, UserForRegistration } from './models/user';
import Service from './Service';

class UserService {
  private static URL_BASE = process.env.REACT_APP_URL_API;

  private static URL_LOGIN = () => `${this.URL_BASE}/v1/auth/login`;
  private static URL_REGISTER = () => `${this.URL_BASE}/user/register`;
  private static URL_USER = () => `${this.URL_BASE}/user`;
  private static URL_FORGOT_PASSWORD = () => `${this.URL_BASE}/v1/auth/forgot-password`;
  private static URL_RESET_PASSWORD = () => `${this.URL_BASE}/v1/auth/reset-password`;
  private static URL_RESEND_VERIFICATION = () => `${this.URL_BASE}/v1/auth/resend-verification`;

  static login(email: string, password: string, lang: Locale): Promise<{ accessToken: string, refreshToken: string } | { message: string}> {
    const deviceId = localStorage.getItem('device_id') || uuidv4();
    const data = {
      email,
      password,
      lang,
      device_id: deviceId,
    };

    localStorage.setItem('device_id', deviceId);

    return Service.fetch(this.URL_LOGIN(), {
      method: 'POST',
      body: data,
    }, true);
  }

  static register(data: UserForRegistration): Promise<{ message: string }> {
    return Service.fetch(this.URL_REGISTER(), {
      method: 'POST',
      body: data,
    }, true);
  }

  static getUser(): Promise<{ data: User }> {
    return Service.get(this.URL_USER(), {
      method: 'GET',
    });
  }

  static updateUser(data: Partial<Pick<User, 'firstName' | 'lastName' | 'phone'>>): Promise<{ data: User }> {
    return Service.patch(this.URL_USER(), data);
  }

  static forgotPassword(email: string): Promise<{ message: string }> {
    return Service.fetch(this.URL_FORGOT_PASSWORD(), {
      method: 'POST',
      body: { email },
    }, true);
  }

  static resetPassword(token: string, password: string): Promise<{ message: string }> {
    return Service.fetch(this.URL_RESET_PASSWORD(), {
      method: 'POST',
      body: { token, password },
    }, true);
  }

  static resendVerificationEmail(email: string): Promise<{ message: string }> {
    return Service.fetch(this.URL_RESEND_VERIFICATION(), {
      method: 'POST',
      body: { email },
    }, true);
  }
}

export default UserService;
